import { ReactElement } from 'react';

import { Notification, NotificationSize, NotificationType, TestableComponentProps } from '@dreryk/react-components';
import { TranslatableText } from '@dreryk/react-common';

type IncompatiblePreferenceNotificationProps = TestableComponentProps & {
   warning?: boolean;
   label: TranslatableText;
};

export const IncompatiblePreferenceNotification = (props: IncompatiblePreferenceNotificationProps): ReactElement => {
   return (
      <Notification
         testId={props.testId}
         size={NotificationSize.SMALLER}
         type={props.warning ? NotificationType.WARNING : NotificationType.INFO}
         label={props.label}
      />
   );
};
